<template>
    <div class="form-group city-form-group input-group">
        <MaterialSelect 
            :disabled="disabled" 
            class="city-form-group city-bg" 
            id="input-service" 
            name="service" 
            label="title" 
            @input="$emit('onChangeSelectedService', $event)" 
            :filterable="true" 
            :options="services" 
            :value="selectedService" 
            v-validate="'required'" 
            :inputClasses="[{'is-invalid': fnHasError('service')}]" 
            :error="fnFirstError('service')"
        >
            {{ servicePlaceholder }}
        </MaterialSelect>
        <div class="input-group-append">
            <button 
                v-if="enableEditService && isValidServiceSelected"
                title="Editar"
                data-toggle="tooltip-city"
                class="btn btn-light" 
                :disabled="!selectedService || disabled"
                type="button" 
                @click.prevent="$emit('onChangeCatalogMode', 'edit', false)">
                <i class="fas fa-pencil-alt"></i>
            </button>
            <button 
                v-if="enableAddService"
                title="Adicionar"
                data-toggle="tooltip-city"
                class="btn btn-light" 
                :disabled="disabled" 
                type="button" 
                @click.prevent="$emit('onChangeCatalogMode', 'edit', true)">
                <i class="fas fa-plus"></i>
            </button>
        </div>
    </div>
</template>

<script>
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        name: 'CatalogServiceSelector',
        mixins: [
            GlobalMixin,
        ],
        components: {
            
        },
        props: {
            disabled: {
                type: Boolean,
                default: false,
            },
            enableAddService: {
                type: Boolean,
                default: false,
            },
            services: {
                type: Array,
            },
            servicePlaceholder: {
                type: String,
                default: 'Serviço',
            },
            selectedService: {
                type: String,
            },
            isValidServiceSelected: {
                type: Boolean,
            }
        },
        computed: {
            enableEditService() {
                return this.service ? this.service.editable : false;
            },
            service() {
                return this.services ? this.services.find(s => s.id == this.selectedService) : null;
            },
        },


    }

</script>

<style scoped lang="scss">

</style>